module.exports = __webpack_public_path__ + "media/apps/main/containers/portfolio/Export/Docx/assets/colourful_team_circle-9bbd179459a1896bab4b4c406239f0df.svg";